import { tokens, IconButton, Typography } from '@beeline.com/bp-design-system';
import React, { useCallback, useEffect } from 'react';
import { useFeatureFlags } from 'src/components/common/featureFlag/useFeatureFlags';
import styled from 'styled-components';
import { useDocsSidePanelIntl } from './translations/useDocsSidePanelIntl';
interface Props {
  onClose: () => void;
  currentPage: string;
  docsPageOrigin: string;
  onNavToNewPage: (currentPage: string) => void;
  onOpenInNewTab: () => void;
}

export const DocsMenuBar: React.FC<React.PropsWithChildren<Props>> = ({
  onClose,
  onNavToNewPage,
  onOpenInNewTab,
  docsPageOrigin
}) => {
  const intl = useDocsSidePanelIntl();
  const { getFeature } = useFeatureFlags();
  const helpDocsFeature = getFeature('in-app-help');
  const handleIFrameClick = useCallback(() => {
    onOpenInNewTab();
  }, [onOpenInNewTab]);
  useEffect(() => {
    const handleIframeMessage = (event: MessageEvent<any>) => {
      if (event.origin !== docsPageOrigin) return;
      if (event.data.type === 'urlUpdate') {
        const iframeUrl = event?.data?.url;
        if (typeof iframeUrl === 'string' && iframeUrl.startsWith(docsPageOrigin)) {
          onNavToNewPage(iframeUrl);
        }
      }
    };
    window.addEventListener('message', handleIframeMessage);
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  });
  return (
    <StyledMenuBar data-test={'docs-menu-bar'}>
      <Typography color={tokens.colorPrimary} variant="label1">
        {helpDocsFeature.label ?? intl.panelTitle}
      </Typography>
      <StyledButtons>
        <StyledIconButton
          iconName="open_in_new"
          dataTest="docs-side-panel-open-docs-in-new-tab-button"
          aria-label={intl.openInNewTabButton}
          tooltipText={intl.openInNewTabButton}
          onClick={() => {
            handleIFrameClick();
          }}
        />
        <StyledIconButton
          iconName="close"
          dataTest="docs-side-panel-close-button"
          aria-label={intl.closePanelButton}
          tooltipText={intl.closePanelButton}
          onClick={() => {
            onClose();
          }}
        />
      </StyledButtons>
    </StyledMenuBar>
  );
};
const StyledButtons = styled.div`
  display: flex;
  align-items: center;
  right: 0;
`;
const StyledMenuBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background-color: white;
  width: 100%;
  padding: 0.625rem 0.75rem;
  border-left: 1px solid ${tokens.colorSurfaceVariant};
`;
const StyledIconButton = styled(IconButton)`
  width: 40px;
  height: 40px;
`;
